<crm-single-select
  [options]="emails"
  [(selectedItem)]="email"
  (selectedItemChange)="emailChange.emit($event)"
  class="w-full {{ isError ? 'ng-invalid ng-dirty' : '' }}"
  [styleClass]="styleClass + (isError ? ' ng-invalid ng-dirty' : '')"
  [showClear]="showClear"
  [isTemplateCombined]="true"
  [filter]="false"
  [appendTo]="appendTo"
  optionLabel="host">
  <ng-template
    #itemTemplate
    let-email="item">
    <ng-container *ngIf="toEmail(email) as email">
      <p class="font-medium">Хост: {{ email.host }}</p>
      <p
        *ngIf="email.login"
        class="text-green-600">
        Логин: {{ email.login }}
      </p>
    </ng-container>
  </ng-template>
</crm-single-select>
